import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Auth from "@/components/auth.vue";
import mainToolbar from "@/components/main_toolbar.vue";
import leftNavDrawer from "@/components/main_leftNavDrawer.vue";
import personLeftNavDrawer from "@/components/people/personLeftNavDrawer.vue";
import rightNavDrawer from "@/components/main_rightNavDrawer.vue";

import adminLeftNav from "@/components/admin_leftNavDrawer.vue";
// import AdminLookups from "@/views/admin/lookups.vue";

// import CaseOverview from "@/components/compliance/cases/tabs/overview";
// import CaseFiles from "@/components/compliance/cases/tabs/files";
// import CaseComments from "@/components/compliance/cases/tabs/comments";
// import CaseActivity from "@/components/compliance/cases/tabs/activity";
// import CaseEmails from "@/components/compliance/cases/tabs/emails";
// import CaseMeta from "@/components/compliance/cases/tabs/meta";
// import CaseActions from "@/components/compliance/cases/tabs/actions";

// import store from "@/store";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        default: Home,
        toolbar: mainToolbar,
        leftNavDrawer,
        rightNavDrawer,
      },
      redirect: "/people",
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () =>
          import(/* webpackChunkName: "about" */ "@/views/About.vue"),
        toolbar: mainToolbar,
        leftNavDrawer,
        rightNavDrawer,
      },
    },
    {
      path: "/people",
      name: "people",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () =>
          import(/* webpackChunkName: "people" */ "@/views/People.vue"),
        toolbar: mainToolbar,
        leftNavDrawer,
        rightNavDrawer,
      },
    },
    {
      path: "/people/bulk",
      name: "peopleBulk",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () =>
          import(/* webpackChunkName: "person" */ "@/views/people/bulk.vue"),
        toolbar: mainToolbar,
        leftNavDrawer,
        rightNavDrawer,
      },
    },
    {
      path: "/people/:id",
      name: "peopleSingle",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () =>
          import(/* webpackChunkName: "person" */ "@/views/people/single.vue"),
        toolbar: mainToolbar,
        leftNavDrawer: personLeftNavDrawer,
        rightNavDrawer,
      },
    },
    {
      path: "/admin",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/Admin.vue"),
      },
    },
    {
      path: "/admin/lookups",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/lookups.vue"),
      },
    },
    {
      path: "/admin/conditions",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/conditions.vue"
          ),
      },
    },
    {
      path: "/admin/reports",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/reports.vue"),
      },
    },
    {
      path: "/admin/payments",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/payments_search.vue"
          ),
      },
    },
    {
      path: "/admin/hpi-extract",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/hpi_extract.vue"
          ),
      },
    },
    {
      path: "/admin/automatic-processes",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/automatic_processes.vue"
          ),
      },
    },
    {
      path: "/admin/automatic-processes/:id",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/automatic_process.vue"
          ),
      },
    },
    {
      path: "/admin/hpifacilities",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/hpi_facilities.vue"
          ),
      },
    },
    {
      path: "/admin/postcodes",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/postcodes.vue"),
      },
    },
    {
      path: "/admin/fees",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/fees.vue"),
      },
    },
    {
      path: "/admin/users",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/users.vue"),
      },
    },
    {
      path: "/admin/roles",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/roles.vue"),
      },
    },
    {
      path: "/admin/hpifacilties",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/roles.vue"),
      },
    },
    {
      path: "/admin/scopes",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/scopes.vue"),
      },
    },
    {
      path: "/admin/qualifications",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/qualifications.vue"
          ),
      },
    },
    {
      path: "/admin/institutions",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/institutions.vue"
          ),
      },
    },
    {
      path: "/admin/options",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(/* webpackChunkName: "admin" */ "@/views/admin/options.vue"),
      },
    },
    {
      path: "/admin/practicingstatusoptions",
      components: {
        toolbar: mainToolbar,
        leftNavDrawer: adminLeftNav,
        default: () =>
          import(
            /* webpackChunkName: "admin" */ "@/views/admin/practicingstatusoptions.vue"
          ),
      },
    },
    {
      path: "/auth",
      name: "auth",
      components: {
        default: Auth,
        // toolbar: mainToolbar,
        // leftNavDrawer: personLeftNavDrawer,
        // rightNavDrawer
      },
      alias: ["/login"],
      // beforeEnter: ifNotAuthenticated
    },
    // {
    //   path: "/cases",
    //   name: "cases",
    //   meta: {
    //     requireAuth: true
    //     // requireRoles: ["compliance_team"]
    //   },
    //   components: {
    //     default: () =>
    //       import(/*webpackChuckName: "compliance" */ "@/components/compliance/cases/index.vue"),
    //     toolbar: mainToolbar,
    //     leftNavDrawer: () =>
    //       import(/*webpackChuckName: "compliance" */ "@/components/compliance/cases/cases_leftNavDrawer.vue"),
    //     rightNavDrawer
    //   }
    // },
    // {
    //   path: "/cases/:id",
    //   name: "case",
    //   components: {
    //     default: () =>
    //       import(/*webpackChuckName: "compliance" */ "@/components/compliance/cases/single.vue"),
    //     toolbar: mainToolbar,
    //     leftNavDrawer: () =>
    //       import(/*webpackChuckName: "compliance" */ "@/components/compliance/cases/cases_leftNavDrawer.vue"),
    //     rightNavDrawer
    //   },
    //   children: [
    //     {
    //       path: "/",
    //       component: CaseOverview,
    //       name: "CaseOverview"
    //     },
    //     {
    //       path: "files",
    //       component: CaseFiles,
    //       name: "CaseFiles"
    //     },
    //     {
    //       path: "comments",
    //       component: CaseComments,
    //       name: "CaseComments"
    //     },
    //     {
    //       path: "activity",
    //       component: CaseActivity,
    //       name: "CaseActivity"
    //     },
    //     {
    //       path: "meta",
    //       component: CaseMeta,
    //       name: "CaseMeta"
    //     },
    //     {
    //       path: "actions",
    //       component: CaseActions,
    //       name: "CaseActions"
    //     },
    //     {
    //       path: "emails",
    //       component: CaseEmails,
    //       name: "CaseEmails"
    //     }
    //   ]
    // }
  ],
});

// function ifNotAuthenticated(to, from, next) {
//   if (!store.getters.isAuthenticated) {
//     next();
//     return;
//   }
//   next("/");
// }

// function ifAuthenticated(to, from, next) {
//   next();
//   return;
//   // if (store.getters.isAuthenticated) {
//   //   next();
//   //   return;
//   // }
//   // next("/login");
// }
